import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { isFunction } from 'ggApp/utils/function';
import { PureTranslator } from 'ggApp/modules/translator/components';

import { UntranslatedValidationError } from '../../utils';
import { FormWrapper, FormRow, Heading, SubHeading, BaseErrorMessage } from './styles';

const FormContainer = ({
    onSubmit,
    className,
    heading,
    subHeading,
    formError,
    children,
    illustration,
    address2FAStyle,
}) => {
    const handleFormSubmit = useCallback(
        (event) => {
            event.preventDefault();

            if (isFunction(onSubmit)) {
                onSubmit();
            }
        },
        [onSubmit],
    );

    let baseErrorMessage = null;

    if (formError?.baseError && formError instanceof UntranslatedValidationError) {
        baseErrorMessage = <PureTranslator tk={formError.baseError} />;
    } else if (formError?.baseError) {
        baseErrorMessage = formError.baseError;
    }

    return (
        <FormWrapper
            className={className}
            onSubmit={handleFormSubmit}
            illustration={illustration}
            address2FAStyle={address2FAStyle}
        >
            {heading && (
                <FormRow address2FAStyle={address2FAStyle}>
                    <Heading>{heading}</Heading>
                </FormRow>
            )}
            {subHeading && (
                <FormRow>
                    <SubHeading>{subHeading}</SubHeading>
                </FormRow>
            )}
            {baseErrorMessage && (
                <FormRow>
                    <BaseErrorMessage>{baseErrorMessage}</BaseErrorMessage>
                </FormRow>
            )}
            {children}
        </FormWrapper>
    );
};

FormContainer.propTypes = {
    className: PropTypes.string,
    heading: PropTypes.node,
    subHeading: PropTypes.node,
    children: PropTypes.node,
    formError: PropTypes.shape({ baseError: PropTypes.string }),
    onSubmit: PropTypes.func.isRequired,
    illustration: PropTypes.shape({}),
    address2FAStyle: PropTypes.bool,
};

FormContainer.defaultProps = {
    className: undefined,
    heading: null,
    subHeading: null,
    children: null,
    formError: undefined,
    illustration: null,
    address2FAStyle: false,
};

export default FormContainer;
